<template>
  <div class="db h-full w-full overflow-auto">
    <vs-row vs-justify="left">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-card class="cardx" fixedHeight>
          <h4>Expiry Reminders</h4>
          <vs-row vs-justify="left">
            <vs-row vs-justify="center" vs-align="center">
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <span style="color: #ff9f43; font-size: 18px">{{
                  '2 items'
                }}</span>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
              >
                <span>
                  <vs-icon icon="double_arrow" style="color: #ff9f43"></vs-icon>
                </span>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <span style="color: #ff9f43; font-size: 18px">Annual Fee</span
                ><br />
              </vs-col>
            </vs-row>
            <vs-row vs-justify="center" vs-align="center">
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <span style="color: #ff9f43; font-size: 18px">{{
                  '2 items'
                }}</span>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
              >
                <span>
                  <vs-icon icon="double_arrow" style="color: #ff9f43"></vs-icon>
                </span>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <span style="color: #ff9f43; font-size: 18px"
                  >Safety Certificate</span
                ><br />
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-card>
      </vs-col>

      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="1"
      ></vs-col>
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-card class="cardx" fixedHeight>
          <h4>Protected Area Alert</h4>
          <vs-row vs-justify="left">
            <vs-row vs-justify="center" vs-align="center">
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <span style="color: #ff9f43; font-size: 18px">{{
                  '4 items'
                }}</span>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="2"
              >
                <span>
                  <vs-icon icon="double_arrow" style="color: #ff9f43"></vs-icon>
                </span>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="4"
              >
                <span style="color: #ff9f43; font-size: 18px"
                  >Last 24 hours</span
                ><br />
              </vs-col>
            </vs-row>
          </vs-row>
        </vs-card>
      </vs-col>
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="1"
      ></vs-col>
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-card class="cardx" fixedHeight>
          <h4>Trips</h4>
          <vs-row vs-justify="center" vs-align="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: green; font-size: 18px">{{ 'Ongoing' }}</span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span>
                <vs-icon icon="double_arrow" style="color: green"></vs-icon>
              </span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: green; font-size: 18px">12 trips</span>
            </vs-col>
          </vs-row>
          <vs-row vs-justify="center" vs-align="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: red; font-size: 18px">{{ 'Cancelled' }}</span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span>
                <vs-icon icon="double_arrow" style="color: red"></vs-icon>
              </span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: red; font-size: 18px">2 trips</span>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
      <vs-col
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="1"
      ></vs-col>
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
        <vs-card class="cardx" fixedHeight>
          <h4>Live Manifest</h4>
          <vs-row vs-justify="center" vs-align="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">{{
                'Captains'
              }}</span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span>
                <vs-icon icon="double_arrow" style="color: #ff9f43"></vs-icon>
              </span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">7 records</span>
            </vs-col>
          </vs-row>
          <vs-row vs-justify="center" vs-align="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">{{
                'Passenger'
              }}</span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span>
                <vs-icon icon="double_arrow" style="color: #ff9f43"></vs-icon>
              </span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">200 souls</span>
            </vs-col>
          </vs-row>
          <vs-row vs-justify="center" vs-align="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">{{ 'Crews' }}</span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span>
                <vs-icon icon="double_arrow" style="color: #ff9f43"></vs-icon>
              </span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">15 souls</span>
            </vs-col>
          </vs-row>
          <vs-row vs-justify="center" vs-align="center">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">{{ 'Cargo' }}</span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
              <span>
                <vs-icon icon="double_arrow" style="color: #ff9f43"></vs-icon>
              </span>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <span style="color: #ff9f43; font-size: 18px">300 kgs</span>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>

    <br />

    <vs-row vs-justify="left">
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
        <vs-card class="cardx" fixedHeight>
          <h4>Vessel Status</h4>
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="donut"
                :options="{
                  chart: {
                    height: 200,
                    type: 'radialBar',
                  },
                  colors: ['#28C76F', '#FF9F43', '#EA5455', '#b4a5a5'],
                  labels: ['Move', 'Idle', 'Park', 'Inactive'],
                  legend: {
                    show: false,
                  },
                  plotOptions: {
                    pie: {
                      donut: {
                        labels: {
                          show: true,
                          total: {
                            show: true,
                          },
                        },
                      },
                    },
                  },
                }"
                :series="[7, 21, 6, 16]"
                height="220"
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  icon="near_me"
                  subtitle="Ongoing Trips"
                  :title="7"
                  style="color: #28c76f"
                ></vs-list-item>
                <vs-list-item
                  icon="pause_circle"
                  subtitle="Idle"
                  :title="21"
                  style="color: #ff9f43"
                ></vs-list-item>
                <vs-list-item
                  icon="stop_circle"
                  subtitle="Park"
                  :title="6"
                  style="color: #ea5455"
                ></vs-list-item>
                <vs-list-item
                  icon="signal_wifi_bad"
                  subtitle="Inactive"
                  :title="16"
                  style="color: #b4a5a5"
                ></vs-list-item>
              </vs-list>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
      </vs-col>
      <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
        <vs-card class="cardx" fixedHeight>
          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
              <h4>Trips Data (Nautical Miles Covered)</h4>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="2">
            </vs-col>
          </vs-row>

          <vs-row vs-justify="left">
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
              <vue-apex-charts
                type="bar"
                height="220"
                :options="{
                  chart: {
                    type: 'bar',
                    height: 200,
                    toolbar: {
                      show: false,
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 4,
                      horizontal: true,
                    },
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  xaxis: {
                    categories: ['V1', 'V2', 'V3', 'V4', 'V5'],
                    title: {
                      text: 'Top Vessels',
                    },
                  },
                }"
                :series="[
                  {
                    name: 'Usage Last 24 hours (km)',
                    data: [200, 10, 50, 0, 700],
                  },
                ]"
              ></vue-apex-charts>
            </vs-col>
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <vs-list>
                <vs-list-item
                  subtitle="Usage Last 24hrs"
                  :title="'1000 nautical miles'"
                ></vs-list-item>
                <vs-list-item
                  subtitle="Overall Usage"
                  :title="'12000 nautical miles'"
                ></vs-list-item>
                <vs-list-item
                  subtitle="Average per Asset"
                  :title="'100 nautical miles'"
                ></vs-list-item>
              </vs-list>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <br />
    <vx-card>
      <vs-tabs>
        <vs-tab label="Vessels" icon="sailing">
          <Fleet_List></Fleet_List>
        </vs-tab>

        <vs-tab label="Captains" icon="engineering">
          <Captain_List></Captain_List>
        </vs-tab>

        <vs-tab label="Crew" icon="engineering">
          <Crew_List></Crew_List>
        </vs-tab>

        <vs-tab label="Trips" icon="route">
          <Route_List></Route_List>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import Fleet_List from './components/Vessel/List.vue';
import Captain_List from './components/Captain/List.vue';
import Crew_List from './components/Crew/List.vue';
import Route_List from './components/Trip/List.vue';

import VueApexCharts from 'vue-apexcharts';

export default {
  data() {
    return {};
  },
  components: {
    VueApexCharts,
    Fleet_List,
    Captain_List,
    Route_List,
    Crew_List,
  },
  created() {},
  methods: {},
  mounted() {},
  destroyed() {},
};
</script>

<style lang="scss">
.db {
  overflow-y: scroll;
}
</style>
